var path = '/templates/zenclerk_s/agencies/sites_user_activity/sites_user_activity.html';
var html = "<div><header>{{$ctrl.agency.title}}</header><div class=\"container-fluid container-limited\"><div class=row><div class=col-sm-12><zcs-project-user-activity projects=$ctrl.projects></zcs-project-user-activity></div></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/zenclerk_s_modules/zenclerk_s/agencies/sites_user_activity/sites_user_activity.html
// module id = 1310
// module chunks = 0